import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcSReadDone16Icon, IcSTimeIcon, MessageErrorIcon, SentIcon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { SendMessageStatus } from 'APP/model/message/messageModel.types';
import { Group } from 'STORE/Groups/Group';

import { useGroupStatusIconPresenter } from './GroupStatusIcon.presenter';
import styles from './GroupStatusIcon.style.m.css';

const ICONS = {
  [SendMessageStatus.Failed]: MessageErrorIcon,
  [SendMessageStatus.Seen]: IcSReadDone16Icon,
  [SendMessageStatus.Sending]: IcSTimeIcon,
  [SendMessageStatus.Sent]: SentIcon,
};

interface IGroupStatusIconProps {
  group: Group;
}

export const GroupStatusIcon: FC<IGroupStatusIconProps> = observer(({ group }) => {
  const presenter = useGroupStatusIconPresenter(group);

  return (
    <IconView
      className={classNames(styles.icon, styles[presenter.status || ''])}
      Icon={presenter.status ? ICONS[presenter.status] : null}
      size={IconViewSizes.Small}
    />
  );
});
